import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({
  children,
  adminOnly = false,
}) {
  const { user, profile, loading, profileError, logout } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="py-16 text-center text-slate-600" role="status">
        Loading account…
      </div>
    );
  }

  if (profileError || (user && !profile)) {
    return (
      <div className="mx-auto max-w-md rounded-2xl bg-white p-6 shadow-sm ring-1 ring-slate-200">
        <h1 className="text-xl font-bold text-slate-900">
          Account access unavailable
        </h1>

        <p className="mt-3 text-sm text-slate-600" role="alert">
          {profileError ||
            "Your account profile is not available yet. If you just registered, please wait a moment. Otherwise, contact the center for help."}
        </p>

        <div className="mt-5 flex flex-wrap gap-3">
          <button
            type="button"
            onClick={() => window.location.reload()}
            className="rounded-xl bg-sky-700 px-4 py-2 font-semibold text-white"
          >
            Try Again
          </button>

          {user && (
            <button
              type="button"
              onClick={async () => {
                try {
                  await logout();
                } catch (error) {
                  console.error("Unable to sign out:", error);
                  window.alert("Unable to sign out. Please try again.");
                }
              }}
              className="rounded-xl border border-slate-300 px-4 py-2 font-semibold text-slate-700"
            >
              Sign Out
            </button>
          )}
        </div>
      </div>
    );
  }

  if (!user) {
    return (
      <Navigate
        to="/parent-login"
        replace
        state={{ from: location }}
      />
    );
  }

  if (adminOnly && profile.role !== "admin") {
    return <Navigate to="/parent" replace />;
  }

  return children;
}
